import { defineAction } from '~/prix'
import { dateOrIsoString } from '~/prix/types/date'
import { z } from 'zod'
import { reportFormatSchema } from '~/utils/server/report'
import equipmentLoanReportAction from './equipmentLoanReport.action.json' with { type: 'json' }
import { equipmentLoanReportSituationValues } from './equipmentLoanReportShared'

const equipmentLoanReportSituationSchema = z.enum(equipmentLoanReportSituationValues).nullish()

const equipmentLoanReportDefinition = defineAction({
  ...equipmentLoanReportAction,

  input: z.object({
    format: reportFormatSchema,
    situation: equipmentLoanReportSituationSchema,
    startDate: dateOrIsoString().nullish(),
    endDate: dateOrIsoString().nullish(),
  }),
  output: z.any(),
})

export default equipmentLoanReportDefinition
